export function deltaToText(delta) {
    return delta
        .map((op) => typeof op.insert === 'string' ? op.insert : op.insert ? ' ' : '')
        .join('');
}
